export class LanguageCulture {
    siteName: string;
    culture: string;
    userName: string;
}